export const CustomPrevIcon = () => (
  <svg 
    width="50" 
    height="50" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="4"
    aria-label="Anterior"
    role="img"
    focusable="false"
  >
    <title>Ir al elemento anterior</title>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const CustomNextIcon = () => (
  <svg 
    width="50" 
    height="50" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="4"
    aria-label="Siguiente"
    role="img"
    focusable="false"
  >
    <title>Ir al siguiente elemento</title>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
